import React from "react"
import autobind from "class-autobind"
import { Paper, CircularProgress } from "material-ui"
import strings from "../../localization/strings"
import WorkflowStore from "../../stores/WorkflowStore"
import WorkflowCard from "../../components/workflow/WorkflowCard"
import { IWorkflow } from "../../models"

interface IState {
	loading: boolean
	accountSetupWorkflow: IWorkflow
}

export default class Workflows extends React.Component<any, IState> {
	constructor(props) {
		super(props)
		this.state = {
			loading: WorkflowStore.getLoadingStatus(),
			accountSetupWorkflow: null,
		}
		autobind(this)
	}

	componentWillMount() {
		this.changeEvent()
	}

	componentDidMount() {
		document.title = `${strings.Training} | ${strings.Findd_Grandd_Central}`
		WorkflowStore.on("change", this.changeEvent)
	}

	componentWillUnmount() {
		WorkflowStore.removeListener("change", this.changeEvent)
	}

	changeEvent() {
		this.setState({
			loading: WorkflowStore.getLoadingStatus(),
			accountSetupWorkflow: WorkflowStore.getAccountSetupWorkflow()
		})
	}

	render() {
		return (
			<div className="page-container Account">
				<div className="page-container-parent">
					<Paper
						zDepth={1}
						className="page-paper"
						style={{ padding: 20, }}
					>
						<div className="pageHeading" style={{ marginBottom: "40px" }}>
							{strings.Training}
						</div>
						{this.state.loading ?
							<div className="spinner">
								<CircularProgress />
							</div> :
							this.state.accountSetupWorkflow ?
								<WorkflowCard workflow={this.state.accountSetupWorkflow} /> :
								<p>{strings.No_pending_trainings}</p>
						}
					</Paper>
				</div>
			</div>
		)
	}
}